module.exports = __webpack_public_path__ + "img/ivy.66f6b553.png";